var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-style"},[_c('div',[_vm._v(_vm._s(_vm.message))]),_c('a',{attrs:{"href":_vm.url}},[_vm._v("Visit Now")])])
}
var staticRenderFns = []

export { render, staticRenderFns }